// Public legal documents, issued by the entity on the marketing site.
const HERAION_SITE_URL = "https://heraion.app";
export const PRIVACY_URL = `${HERAION_SITE_URL}/privacy`;
export const TERMS_URL = `${HERAION_SITE_URL}/terms`;
